import { render } from "./Translator.vue?vue&type=template&id=d9dbdbee&scoped=true"
import script from "./Translator.vue?vue&type=script&lang=js"
export * from "./Translator.vue?vue&type=script&lang=js"

import "./Translator.vue?vue&type=style&index=0&id=d9dbdbee&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/toki-pona-translator/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9dbdbee"]])

export default __exports__